var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 348,
    viewBox: "0 0 388 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.094 6.79492L270.906 6.79492C283.053 6.79493 294.277 13.2753 300.351 23.7949L377.257 157C383.33 167.52 383.33 180.48 377.257 191L300.351 324.205C294.277 334.725 283.053 341.205 270.906 341.205L117.094 341.205C104.947 341.205 93.7227 334.725 87.6492 324.205L10.7432 191C4.66965 180.48 4.66965 167.52 10.7432 157L87.6491 23.7949C93.7227 13.2753 104.947 6.79492 117.094 6.79492Z",
    stroke: "#D98F39",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexFigma);
export default __webpack_public_path__ + "static/media/hex-figma.4670b79fc42ec6854f3b8df23fafc029.svg";
export { ForwardRef as ReactComponent };